
// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

// export default function DropDown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   isDisabled = false, // ✅ New prop
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (selected && Array.isArray(options)) {
//       const found = options.find((option) => option.id === selected);
//       if (found) {
//         setSelectedLabel(found.label);
//       } else {
//         setSelectedLabel("");
//       }
//     }
//   }, [selected, options]);

//   const handleClick = (option) => {
//     if (isDisabled) return; // 🔒 Prevent changes if disabled
//     setSelected(option.id);
//     setIsActive(false);
//     setSelectedLabel(option.label);
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className || ""}`}
//       style={{
//         width,
//         ...style,
//         pointerEvents: isDisabled ? "none" : "auto",
//         opacity: isDisabled ? 0.7 : 1,
//       }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div
//         className="dropdown-btn"
//         onClick={() => {
//           if (!isDisabled) setIsActive(!isActive);
//         }}
//         style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
//       >
//         {selectedLabel || "Select..."}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{ width: customWidth, top: customTop }}
//         >
//           {options.map((option) => (
//             <div
//               key={option.id}
//               className="dropdown-item-CBV2"
//               onClick={() => handleClick(option)}
//             >
//               {option.label}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }






import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  isDisabled = false,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selected && Array.isArray(options)) {
      const found = options.find((option) => option.id === selected);
      if (found) {
        setSelectedLabel(found.label);
      } else {
        setSelectedLabel("");
      }
    }
  }, [selected, options]);

  const handleClick = (option) => {
    if (isDisabled) return;
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div
      className={`dropdown-CB ${className || ""}`}
      style={{
        width,
        ...style,
        pointerEvents: isDisabled ? "none" : "auto",
        opacity: isDisabled ? 0.7 : 1,
      }}
      ref={dropdownRef}
    >
      <label
        className="dropdown-CB-label"
        style={{
          fontSize: "14px",
          color: "var(--DppLabelText, #6A6A6A)",
          display: "block",
          marginBottom: "5px",
        }}
      >
        {label}
        {isRequired && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={() => {
          if (!isDisabled) setIsActive(!isActive);
        }}
        style={{
          cursor: isDisabled ? "not-allowed" : "pointer",
          color: "var(--Gray-2, #6A6A6A)",
          fontSize: "14px",
          borderRadius: "0px",
          backgroundColor: "var(--DppInputBackground, #ffffff)",
          border: "1px solid var(--DppInputBorder, #d0d0d0)",
        }}
      >
        {selectedLabel || "Select..."}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop, fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
              style={{ fontSize: "14px", color: "var(--Gray-2, #6A6A6A)" }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}